import {
  // ModalCompAdvance,
  ButtonComp,
  TableCompData,
} from "../../../../components";
import EmptyTable from "../../../../components/Common/EmptyTable";
import FilterFind from "../../../../components/FilterFind";
import { pendingMemberHeader } from "../../../../utils/TableHeader";
import TablePagination from "../../../../components/Table/Pagination";
import TableSkeletonLoader from "../../../../components/Common/TableSkeletonLoader";

export default function PendingMemberComp({
  // title,
  // TableDropDown,
  // modalPage,
  setModalPage,
  setModalToggle,
  // useModal,
  // modalToggle,
  tableData,
  isFetching,
  pagination,
  setPageNumber,
  setMemberId,
  onViewDetails,
  onSelectedRowsChange,
  clearSelectedRows,
  selectedCount = 0,
  onBulkApproveClick,
  isBulkApproving = false,
}) {
  return (
    <section className="mx-2 mx-lg-4 min-vh-100 animate__animated animate__fadeIn">
      <FilterFind
        title={"Pending members"}
        searchValue=""
        placeholder="Search members..."
      />
      {selectedCount > 0 && (
        <div
          className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3 px-1"
          style={{
            background: "rgba(49, 119, 140, 0.08)",
            border: "1px solid rgba(49, 119, 140, 0.25)",
            borderRadius: 10,
            padding: "12px 16px",
          }}
        >
          <span className="text-black fw-2 mb-0">
            {selectedCount} member{selectedCount === 1 ? "" : "s"} selected
          </span>
          <ButtonComp
            btnText={
              isBulkApproving
                ? "Approving…"
                : `Approve selected (${selectedCount})`
            }
            btnClassName={"border-0 text-white rounded py-2 px-3"}
            ButtonInlineStyle={{
              background: "#19BC31",
              minWidth: "fit-content",
              whiteSpace: "nowrap",
            }}
            disabled={isBulkApproving || selectedCount === 0}
            onClick={onBulkApproveClick}
          />
        </div>
      )}
      <div className="mb-5">
        <TableCompData
          marginBottom={"0"}
          selectableRows
          onSelectedRowsChange={onSelectedRowsChange}
          clearSelectedRows={clearSelectedRows}
          columns={pendingMemberHeader(
            setModalToggle,
            setModalPage,
            setMemberId,
            onViewDetails
          )}
          data={tableData}
          progressPending={isFetching}
          progressComponent={<TableSkeletonLoader rows={5} columns={7} />}
          message={
            !isFetching ? (
              <EmptyTable
                Message={"There are currently no pending members"}
                // btnText={"Add Staff"}
              />
            ) : null
          }
        />
      </div>
      {!isFetching && tableData.length > 0 && (
        <TablePagination handlePageChange={setPageNumber} {...pagination} />
      )}
    </section>
  );
}
